import Vue from 'vue'
import Router from 'vue-router'
import AkasakaDrivens from './views/AkasakaDrivens'
import axios from './axios'
import store from './store'

Vue.use(Router)

// lazy-loaded
function loadView(view) {
	return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const routerMode = process.env.NODE_ENV == 'development' ? 'hash' : 'history'

const router = new Router({
	mode: 'history',
	base: "/AkasakaDrivens/",
	routes: [
		
		{
			path: '/',
			name: 'AkasakaDrivens',
			component: AkasakaDrivens,
		},
		{
			path: '/terms_of_service',
			name: 'terms_of_service',
			component: loadView('Terms_of_service')
		},
		{
			path: '/privacy_policy',
			name: 'privacy_policy',
			component: loadView('Privacy_policy')
		},
		{
			path: '/money_settlement',
			name: 'money_settlement',
			component: loadView('Money_settlement')
		},
		{
			path: '/specific_business',
			name: 'specific_business',
			component: loadView('Specific_business')
		},

	
	
	
	]
})

router.beforeEach(async (to, from, next) => {
	switch (to.name) {
		case "special":
			store.commit("SET_TOPNAVBTN_INDEX", 4);
			break;
		case "feedback":
			store.commit("SET_TOPNAVBTN_INDEX", 5);
			break;
		default:
			break;
	}
	
	if (to.meta.requiresAuth) {
		if (store.state.TOKEN) {
			await axios.get('/user/checkToken').then(v => {
				next()
			})
		} else {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		}
	} else {
		next()
	}
})

export default router
